import { render, staticRenderFns } from "./SopDataTable.vue?vue&type=template&id=3f6a7996&"
import script from "./SopDataTable.vue?vue&type=script&lang=js&"
export * from "./SopDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports